import Glide from '@glidejs/glide'


export default (function (Drupal, drupalSettings, once) {

  Drupal.behaviors.carouselHero = {
    attach: function (context, settings) {
      const sliders = document.querySelectorAll('.glide');
      if (sliders.length > 0) {
        sliders.forEach((slider) => {
          let glide = new Glide(slider, {
            type: 'carousel',
            gap: '0',
            animationDuration: '800',
          })

          glide.mount();
        });
      }
    },
  };

  Drupal.behaviors.arrowAnimation = {
    attach: function (context, settings) {

      const preloadImage = (src) => {
        return new Promise((resolve, reject) => {
          let img = new Image()
          img.onload = resolve
          img.onerror = reject
          img.src = src
        })
      }

      const switchAnimation = (arrow) => {
        const d = new Date().getTime();
        const host = window.location.protocol + "//" + window.location.hostname;
        const url = host + arrow + d;
        const link = event.target;
        preloadImage(url).then(() => {
          link.style.backgroundImage = "url('" + url + "')";
        })
      }

      const links = document.querySelectorAll('.cta-link');

      links.forEach(link => {
        link.addEventListener('mouseenter', function () { switchAnimation("/themes/custom/faigle/src/assets/images/icons/link-arrow-animated.svg?ver=") });
        link.addEventListener('mouseleave', function () { switchAnimation("/themes/custom/faigle/src/assets/images/icons/link-arrow-animated-reverse.svg?ver=") });
      })

      const linksBlue2 = document.querySelectorAll('.cta-link-blue-2');

      linksBlue2.forEach(link => {
        link.addEventListener('mouseenter', function () { switchAnimation("/themes/custom/faigle/src/assets/images/icons/link-arrow-animated-2.svg?ver=") });
        link.addEventListener('mouseleave', function () { switchAnimation("/themes/custom/faigle/src/assets/images/icons/link-arrow-animated-reverse-2.svg?ver=") });
      })

      const linksBlue3 = document.querySelectorAll('.cta-link-blue-3');

      linksBlue3.forEach(link => {
        link.addEventListener('mouseenter', function () { switchAnimation("/themes/custom/faigle/src/assets/images/icons/link-arrow-animated-3.svg?ver=") });
        link.addEventListener('mouseleave', function () { switchAnimation("/themes/custom/faigle/src/assets/images/icons/link-arrow-animated-reverse-3.svg?ver=") });
      })

      const linksBlue4 = document.querySelectorAll('.cta-link-blue-4');

      linksBlue4.forEach(link => {
        link.addEventListener('mouseenter', function () { switchAnimation("/themes/custom/faigle/src/assets/images/icons/link-arrow-animated-4.svg?ver=") });
        link.addEventListener('mouseleave', function () { switchAnimation("/themes/custom/faigle/src/assets/images/icons/link-arrow-animated-reverse-4.svg?ver=") });
      })
    }
  };

  Drupal.behaviors.navigationMenu = {
    attach: function (context, settings) {
      const width  = window.innerWidth;
      
      var toggleButton = document.getElementById('menuToggle');
      var regionNavigation = document.getElementsByTagName('header');
      toggleButton.addEventListener("click", function () {
        if(regionNavigation[0].classList.contains('region-navigation__open')) {
          regionNavigation[0].classList.add('region-navigation__close')
          regionNavigation[0].classList.remove('region-navigation__open')
          document.getElementsByTagName('main')[0].classList.remove('main__fixed');
          document.getElementsByTagName('footer')[0].classList.remove('footer_remove');
        } else {
          regionNavigation[0].classList.add('region-navigation__open')
          regionNavigation[0].classList.remove('region-navigation__close');
          document.getElementsByTagName('main')[0].classList.add('main__fixed');
          document.getElementsByTagName('footer')[0].classList.add('footer_remove');
        }
      });

      // Uncheck menu input on page load.
      toggleButton.getElementsByTagName('input')[0].checked = false;
      toggleButton.getElementsByTagName('input')[0].autocomplete = "off";

      const navbar = document.getElementsByTagName('header');
      
      // Language switcher block mouse navigation.
      const onMouseLeave = () => {
        navbar[0].classList.remove("nav-hover--sticky");
        let lang = document.getElementsByClassName('language-switcher__open');
        if(lang.length > 0) {
          navbar[0].classList.add("nav-hover--sticky");
        }

        let searchClass = document.getElementsByClassName('search-bar__open');
        if(searchClass.length > 0) {
          navbar[0].classList.add("nav-hover--sticky");
        }
      }

      const onMouseEnter = () => {
        navbar[0].classList.add("nav-hover--sticky");
      }
      if (width > 960) {
        document.addEventListener('mousemove', function(event){
          if(event.clientY < 145) {
            navbar[0].classList.add("nav-hover--sticky");
          }
        })
      }

      var langButton = document.getElementsByClassName('language-switcher__button');
      langButton[0].addEventListener("click", function (event) {
        event.stopPropagation();
        document.getElementsByClassName('language-switcher')[0].classList.toggle('language-switcher__open');
        
      });

      window.addEventListener('click', function () {
        let langClass = document.getElementsByClassName('language-switcher')[0].classList.contains('language-switcher__open');
        if(langClass) {
          document.getElementsByClassName('language-switcher')[0].classList.remove('language-switcher__open');
          navbar[0].classList.remove("nav-hover--sticky");
        }
      })

      if (width > 960) {
        navbar[0].addEventListener('mouseleave', onMouseLeave);
        navbar[0].addEventListener('mouseenter', onMouseEnter);
      }


      var searchPage = document.getElementsByClassName('search-layout');
      if(searchPage.length > 0) {
        let navbar = document.getElementsByTagName('header')[0];
        navbar.classList.add("nav-hover--sticky");
        navbar.removeEventListener('mouseenter', onMouseEnter)
        navbar.removeEventListener('mouseleave', onMouseLeave)
      }
      
      // OnScroll event handler
      const onScroll = () => {

        // Get scroll value
        const scroll = document.documentElement.scrollTop

        // If scroll value is more than 20 - add class
        if (scroll > 50) {
          navbar[0].classList.add("nav-is-sticky");
          navbar[0].classList.remove("nav-is-not-sticky");
          navbar[0].removeEventListener('mouseenter', onMouseEnter)
        } else {
          navbar[0].classList.add("nav-is-not-sticky");
          navbar[0].classList.remove("nav-is-sticky");
          navbar[0].addEventListener('mouseenter', onMouseEnter);
        }
        
      }

      // Use the OnScroll function
      window.addEventListener('scroll', onScroll);
      if (width < 960) {
        const links = document.querySelectorAll('.menu-main-navigation__item--expanded');
        links.forEach(link => {
          link.addEventListener("click", function (event) {
            this.classList.toggle('menu-main-navigation__item_open')
          });
          link.querySelector('.menu-main-navigation__submenu').addEventListener("click", function (event) {
            event.stopPropagation();
          });
        })

        document.getElementById('views-exposed-form-search-api-page-1').addEventListener("click", function (event) {
          this.submit();
        });    
      }    

      // If no hero banner is peresent. 
      let heroBanner = document.querySelectorAll('.paragraph--type--faigle-hero-section');
      if(heroBanner.length < 1) {
        document.querySelectorAll('.layout-container')[0].classList.add('no-hero-banner');
      }

    },
  };

  // Hover animation for the cards.
  Drupal.behaviors.cardsHoverEffect = {
    attach: function (context, settings) {
      const cardCoverLinks = document.querySelectorAll('.cover-link');

      if (cardCoverLinks.length > 0) {
        cardCoverLinks.forEach(coverLink => {
          const cardWrapper = coverLink.parentElement;
          const ctaLink = cardWrapper.querySelector('.field--name-field-link a, .cta-link');

          if (ctaLink) {
            const triggerEvent = (event) => {
              coverLink.addEventListener(event, function () {
                const createEvent = new Event(event);
                ctaLink.dispatchEvent(createEvent);
                ctaLink.classList.toggle('hover');
              });
            }

            triggerEvent('mouseenter');
            triggerEvent('mouseleave');
          }
        })
      }

    }
  }


  // Paragraph Benifit
  Drupal.behaviors.ParagraphBenifit = {
    attach: function (context, settings) {
      const anchorLink = document.querySelectorAll('.paragraph-faigle-benefit__text .field--type-text-long a');
      anchorLink.forEach(link => {
        link.removeAttribute('title')
      })
    }
  }

  // SearchBar JS
  Drupal.behaviors.SearchBar = {
    attach: function (context, settings) {
      var submitButton = document.getElementById('search-bar-icon');
      submitButton.addEventListener("click", function (event) {
        event.stopPropagation();
        this.parentElement.classList.toggle('search-bar__open')
      });


      window.addEventListener('click', function (event) {
        let searchClass = document.getElementById('search-bar-icon').parentElement.classList.contains('search-bar__open');

        var rect = event.target.getBoundingClientRect();
        var y = event.clientY - rect.top;  //y position within the element.
        if (y > 145) {
          if(searchClass) {
            document.getElementById('search-bar-icon').parentElement.classList.remove('search-bar__open');
            document.getElementsByTagName('header')[0].classList.remove("nav-hover--sticky");
          }
        }
      })
    }
  }

})(Drupal, drupalSettings, once);




